/*
 * Silver Gardens
 * Collection / Search Card Configurator V2.1
 *
 * Responsive image sizing with extra detail for desktop and mobile.
 */

(function () {
  "use strict";

  // The browser applies screen pixel density separately.
  var IMAGE_QUALITY_FACTOR = 1.5;

  if (
    window.SGProductCardConfigurator &&
    window.SGProductCardConfigurator.ready
  ) {
    // Keep initialization idempotent if the theme editor re-executes this asset.
    return;
  }

  function configImageSrcset(image) {
    if (!image || !/([?&])width=\d+/.test(image)) {
      return "";
    }
    return [240, 360, 540, 720, 900, 1200].map(function (width) {
      return image.replace(/([?&]width=)\d+/, "$1" + width) + " " + width + "w";
    }).join(", ");
  }

  function readConfig(node) {
    return {
      node: node,
      variantId: node.dataset.variantId || "",
      pot: node.dataset.pot || "",
      height: node.dataset.height || "",
      color: node.dataset.color || "",
      available: node.dataset.available === "true",
      price: node.dataset.price || "",
      priceCents: Number(node.dataset.priceCents || 0),
      potImage: node.dataset.potImage || "",
      comparePrice: node.dataset.comparePrice || "",
      hasCompare: node.dataset.hasCompare === "true",
      url: node.dataset.url || "",
      image: node.dataset.image || "",
      imageSrcset: node.dataset.imageSrcset || configImageSrcset(node.dataset.image || ""),
      linkedPotId: node.dataset.linkedPotId || ""
    };
  }

  function getConfigs(card) {
    return Array.prototype.map.call(
      card.querySelectorAll("[data-sg-card-config]"),
      readConfig
    );
  }

  function isNurseryPot(value) {
    return String(value || "")
      .toLowerCase()
      .indexOf("nursery") !== -1;
  }

  function matches(config, criteria) {
    return Object.keys(criteria).every(function (key) {
      return criteria[key] === undefined || config[key] === criteria[key];
    });
  }

  function configExists(configs, criteria) {
    return configs.some(function (config) {
      return matches(config, criteria);
    });
  }

  function availableConfigExists(configs, criteria) {
    return configs.some(function (config) {
      return config.available && matches(config, criteria);
    });
  }

  function firstAvailable(configs, criteria) {
    return (
      configs.find(function (config) {
        return config.available && matches(config, criteria || {});
      }) || null
    );
  }

  function findInitialConfig(card, configs) {
    var variantId = card.getAttribute("data-sg-card-variant-id");

    var byId = configs.find(function (config) {
      return config.variantId === variantId;
    });

    if (byId && byId.available) {
      return byId;
    }

    var initialPot = card.dataset.sgInitialPot || "";
    var initialHeight = card.dataset.sgInitialHeight || "";
    var initialColor = card.dataset.sgInitialColor || "";

    var exact = configs.find(function (config) {
      return (
        config.available &&
        config.pot === initialPot &&
        config.height === initialHeight &&
        config.color === initialColor
      );
    });

    if (exact) {
      return exact;
    }

    var sameHeightWhite = configs.find(function (config) {
      return (
        config.available &&
        config.height === initialHeight &&
        config.color.toLowerCase() === "white"
      );
    });

    if (sameHeightWhite) {
      return sameHeightWhite;
    }

    var sameHeight = firstAvailable(configs, {
      height: initialHeight
    });

    if (sameHeight) {
      return sameHeight;
    }

    return firstAvailable(configs, {}) || configs[0] || null;
  }

  function scoreCandidate(candidate, current, changedOption) {
    var score = 0;

    ["height", "pot", "color"].forEach(function (key) {
      if (key === changedOption) {
        return;
      }

      if (candidate[key] === current[key]) {
        score += key === "height" || key === "pot" ? 6 : 4;
      }
    });

    if (
      !isNurseryPot(candidate.pot) &&
      candidate.color.toLowerCase() === "white"
    ) {
      score += 2;
    }

    if (isNurseryPot(candidate.pot)) {
      score += 1;
    }

    return score;
  }

  function chooseConfig(configs, current, changedOption, changedValue) {
    var desired = {
      pot: current.pot,
      height: current.height,
      color: current.color
    };

    desired[changedOption] = changedValue;

    var exact = configs.find(function (config) {
      return (
        config.available &&
        config.pot === desired.pot &&
        config.height === desired.height &&
        config.color === desired.color
      );
    });

    if (exact) {
      return exact;
    }

    var candidates = configs.filter(function (config) {
      return (
        config.available &&
        config[changedOption] === changedValue
      );
    });

    if (!candidates.length) {
      return null;
    }

    candidates.sort(function (a, b) {
      return (
        scoreCandidate(b, current, changedOption) -
        scoreCandidate(a, current, changedOption)
      );
    });

    return candidates[0];
  }

  function updateHeightButton(button, current, configs) {
    var value = button.dataset.value || "";
    var exists = configExists(configs, { height: value });
    var available = availableConfigExists(configs, { height: value });
    var selected = current.height === value;

    button.hidden = !exists;
    button.disabled = exists && !available;
    button.classList.toggle("is-selected", selected);
    button.classList.toggle("is-unavailable", exists && !available);
    button.setAttribute("aria-pressed", selected ? "true" : "false");
  }

  function availablePotConfig(configs, current, pot) {
    return firstAvailable(configs, {height:current.height,pot:pot,color:current.color}) ||
      firstAvailable(configs, {height:current.height,pot:pot});
  }

  function updatePotButton(button, current, configs, initialPot) {
    var pot=button.dataset.value||"";
    var exists=configExists(configs,{height:current.height,pot:pot});
    var available=availableConfigExists(configs,{height:current.height,pot:pot});
    var selected=current.pot===pot;
    var wrap=button.closest("[data-sg-grid-pot-wrap]");
    if(wrap) wrap.hidden=!exists;
    button.hidden=!exists;
    button.disabled=!available;
    button.classList.toggle("is-selected",selected);
    button.classList.toggle("is-unavailable",exists&&!available);
    button.setAttribute("aria-pressed",selected?"true":"false");
    var option=availablePotConfig(configs,current,pot);
    var image=button.querySelector(".sg-card-configurator__pot-thumb");
    if(image&&option&&option.potImage&&image.getAttribute("src")!==option.potImage){
      image.removeAttribute("srcset");
      image.setAttribute("src",option.potImage);
    }
  }

  function updateColorButton(button,current,configs){
    var color=button.dataset.value||"";
    var pot=button.dataset.pot||current.pot;
    var criteria={height:current.height,pot:pot,color:color};
    var exists=configExists(configs,criteria);
    var available=availableConfigExists(configs,criteria);
    var selected=current.pot===pot&&current.color===color;
    button.hidden=!available;
    button.disabled=!available;
    button.classList.toggle("is-selected",selected);
    button.classList.toggle("is-unavailable",exists&&!available);
    button.setAttribute("aria-pressed",selected?"true":"false");
  }

  function updateButtons(card,current,configs){
    var initialPot=card.dataset.sgInitialPot||current.pot;
    card.querySelectorAll('[data-sg-option-button][data-option="height"]')
      .forEach(function(b){updateHeightButton(b,current,configs);});
    card.querySelectorAll('[data-sg-option-button][data-option="pot"]')
      .forEach(function(b){updatePotButton(b,current,configs,initialPot);});
    card.querySelectorAll('[data-sg-option-button][data-option="color"]')
      .forEach(function(b){updateColorButton(b,current,configs);});
    var colourRow=card.querySelector("[data-sg-color-row]");
    if(colourRow){
      var swatches=colourRow.querySelectorAll('[data-option="color"]');
      var anyAvailable=Array.prototype.some.call(swatches,function(b){return !b.hidden;});
      colourRow.hidden=isNurseryPot(current.pot)||!anyAvailable;
    }
  }

  function updatePrice(card, config) {
    var price = card.querySelector("[data-sg-card-price]");

    var comparePrice = card.querySelector(
      "[data-sg-card-compare-price]"
    );

    if (price) {
      price.textContent = config.price;
      price.classList.toggle("sale", config.hasCompare);
    }

    if (comparePrice) {
      comparePrice.textContent = config.comparePrice;
      comparePrice.hidden = !config.hasCompare;
    }
  }

  function getMainImage(card) {
    var image = card.querySelector(
      ".product-item__image-link .product-item__image img"
    );

    if (!image) {
      image = card.querySelector(".product-item__image-link img");
    }

    return image;
  }

  function getRenderedImageSizes(image) {
    var bounds = image.getBoundingClientRect();

    // Hidden cards are measured again when they become visible.
    if (!bounds.width || !bounds.height) {
      return "";
    }

    var sourceWidth =
      image.naturalWidth ||
      Number(image.getAttribute("width"));

    var sourceHeight =
      image.naturalHeight ||
      Number(image.getAttribute("height"));

    var displayWidth = bounds.width;

    // Include the extra scale caused by cover cropping.
    if (
      sourceWidth > 0 &&
      sourceHeight > 0 &&
      window.getComputedStyle(image).objectFit === "cover"
    ) {
      displayWidth = Math.max(
        displayWidth,
        bounds.height * sourceWidth / sourceHeight
      );
    }

    return Math.ceil(displayWidth * IMAGE_QUALITY_FACTOR) + "px";
  }

  function syncImageSizes(card) {
    var image = getMainImage(card);

    if (!image) {
      return;
    }

    var sizes = getRenderedImageSizes(image);

    if (sizes && image.getAttribute("sizes") !== sizes) {
      image.setAttribute("sizes", sizes);
    }
  }

  function scheduleImageSizing(card) {
    if (card._sgImageSizingQueued) {
      return;
    }

    card._sgImageSizingQueued = true;

    window.requestAnimationFrame(function () {
      card._sgImageSizingQueued = false;
      syncImageSizes(card);
    });
  }

  function setupImageSizing(card) {
    if (card._sgImageSizingReady) {
      return;
    }

    var image = getMainImage(card);

    if (!image) {
      return;
    }

    card._sgImageSizingReady = true;

    // Update sizing after a variant image with a different ratio loads.
    image.addEventListener("load", function () {
      scheduleImageSizing(card);
    });

    if ("ResizeObserver" in window) {
      card._sgImageResizeObserver = new window.ResizeObserver(
        function () {
          scheduleImageSizing(card);
        }
      );

      card._sgImageResizeObserver.observe(image);
    }

    syncImageSizes(card);
  }

  function updateImage(card, config) {
    if (!config.image) {
      return;
    }

    var image = getMainImage(card);

    if (!image) {
      return;
    }

    // Apply measured sizing before changing the image sources.
    syncImageSizes(card);

    if (config.imageSrcset) {
      image.setAttribute("srcset", config.imageSrcset);
    } else {
      image.removeAttribute("srcset");
    }

    image.setAttribute("src", config.image);
  }

  function updateLinks(card, config) {
    if (!config.url) {
      return;
    }

    var imageLink = card.querySelector(".product-item__image-link");

    var titleLink = card.querySelector(
      ".product-item__product-title a"
    );

    if (imageLink) {
      imageLink.href = config.url;
    }

    if (titleLink) {
      titleLink.href = config.url;
    }

    // Keep the full-page link in sync with selected height / pot / colour.
    card
      .querySelectorAll("[data-sg-card-product-page-link]")
      .forEach(function (link) {
        link.href = config.url;
      });

    card
      .querySelectorAll(".product-item__product-form-variant-input")
      .forEach(function (input) {
        input.value = config.variantId;
      });
  }

  function applyConfig(card, config, configs, keepServerImage) {
    if (!config) {
      return;
    }

    card._sgCurrentConfig = config;

    card.setAttribute(
      "data-sg-card-variant-id",
      config.variantId
    );

    updateButtons(card, config, configs);
    updatePrice(card, config);
    // Liquid has already rendered the right initial image for this variant.
    // Avoid reassigning src/srcset on mobile homepage initialization.
    if (!keepServerImage) {
      updateImage(card, config);
    }
    updateLinks(card, config);
  }

  // Alternate variant images load only after a shopper selects that option.
  // Avoid prefetching every combination for cards that may never be opened.

  // Start each product-card pot carousel at the first Luma option.
  // Nursery Pot stays one swipe to the left, but nothing is cut in half on load.
  // This changes the visible carousel position only — not the selected variant.
  function positionInitialPotStart(card) {
    if (card._sgPotStartPositioned) return;

    var track = card.querySelector(".sg-card-configurator__options--pots");
    if (!track) return;

    var visible = Array.prototype.filter.call(
      track.querySelectorAll("[data-sg-grid-pot-wrap]"),
      function (item) {
        var option = item.querySelector('[data-option="pot"]');
        return !item.hidden && option && !option.hidden;
      }
    );
    if (!visible.length) return;

    var firstLuma = visible.find(function (item) {
      var option = item.querySelector('[data-option="pot"]');
      return option && /luma/i.test(option.dataset.value || "");
    });
    var firstDecorative = visible.find(function (item) {
      var option = item.querySelector('[data-option="pot"]');
      return option && !isNurseryPot(option.dataset.value || "");
    });
    var firstShown = firstLuma || firstDecorative || visible[0];
    if (!firstShown) return;

    card._sgPotStartPositioned = true;
    window.requestAnimationFrame(function () {
      var trackBounds = track.getBoundingClientRect();
      var firstBounds = firstShown.getBoundingClientRect();
      if (trackBounds.width < 1 || firstBounds.width < 1) {
        card._sgPotStartPositioned = false;
        return;
      }

      // Align the entire Luma tile with the left edge of the pot carousel.
      var offset = firstBounds.left - trackBounds.left + track.scrollLeft;
      var target = Math.max(0, Math.round(offset - 1));
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (maxScroll < target) {
        // Short carousels need a small invisible tail to align Luma fully.
        track.style.setProperty("--sg-pot-start-tail", Math.ceil(target - maxScroll + 4) + "px");
      } else {
        track.style.removeProperty("--sg-pot-start-tail");
      }
      track.scrollLeft = target;
    });
  }

  function initCard(card) {
    if (card._sgConfiguratorReady) {
      scheduleImageSizing(card);
      return;
    }

    var configs = getConfigs(card);

    if (!configs.length) {
      return;
    }

    var initialConfig = findInitialConfig(card, configs);

    if (!initialConfig) {
      return;
    }

    card._sgConfiguratorReady = true;
    card._sgConfigs = configs;

    setupImageSizing(card);
    var keepServerImage =
      deferOffscreenCards &&
      card.getAttribute("data-sg-card-variant-id") === initialConfig.variantId;
    applyConfig(card, initialConfig, configs, keepServerImage);
    positionInitialPotStart(card);

    card
      .querySelectorAll("[data-sg-option-button]")
      .forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (button.disabled || button.hidden) {
            return;
          }

          var current = card._sgCurrentConfig;

          if (!current) {
            return;
          }

          var option = button.dataset.option;
          var value = button.dataset.value;

          var next;
          if (option === "color" && button.dataset.pot) {
            next = firstAvailable(configs, {
              height:current.height, pot:button.dataset.pot, color:value
            });
          } else {
            next = chooseConfig(configs,current,option,value);
          }

          if (!next) {
            return;
          }

          applyConfig(card, next, configs);
        });
      });


  }

  function init(root) {
    var scope = root || document;

    scope
      .querySelectorAll('.product-item[data-sg-configurator="true"]')
      .forEach(initCard);
    // Re-check matched card rows whenever a collection or homepage rail refreshes.
    observeMobileProductTitleLists();
    queueMobileProductTitleAlign();
  }

  /* Align adjacent mobile product cards only when a name wraps.
     This avoids the permanent empty second line underneath short names.
     Grouping by two matches the two-column mobile collection and homepage rails. */
  var sgCardTitleAlignQueued = false;
  function alignMobileProductTitles() {
    sgCardTitleAlignQueued = false;
    var lists = document.querySelectorAll(
      ".sggc-products, .sgc-products, .collection__products"
    );
    lists.forEach(function (list) {
      var cards = Array.prototype.map.call(list.children, function (child) {
        var card = child.matches('.product-item[data-sg-configurator="true"]')
          ? child : child.querySelector('.product-item[data-sg-configurator="true"]');
        return card;
      }).filter(Boolean);
      var titles = cards.map(function (card) {
        return card.querySelector(".product-item__product-title");
      });
      // Clear any previous pair alignment before measuring natural heights.
      titles.forEach(function (title) {
        if (title) title.style.removeProperty("min-height");
      });
      if (!window.matchMedia("(max-width: 749px)").matches) return;
      if (cards.length < 2 || !list.getBoundingClientRect().width) return;

      var visibleWidth = list.getBoundingClientRect().width;
      var cardWidth = cards[0].getBoundingClientRect().width;
      if (cardWidth < 1 || visibleWidth / cardWidth < 1.65) return;

      for (var i = 0; i < titles.length; i += 2) {
        var a = titles[i], b = titles[i + 1];
        if (!a || !b || !a.getBoundingClientRect().width ||
            !b.getBoundingClientRect().width) continue;
        var highest = Math.ceil(Math.max(
          a.getBoundingClientRect().height,
          b.getBoundingClientRect().height
        ));
        if (highest > 0) {
          a.style.minHeight = highest + "px";
          b.style.minHeight = highest + "px";
        }
      }
    });
  }
  function queueMobileProductTitleAlign() {
    if (sgCardTitleAlignQueued) return;
    sgCardTitleAlignQueued = true;
    window.requestAnimationFrame(alignMobileProductTitles);
  }
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
    queueMobileProductTitleAlign();
  });
  window.addEventListener("resize", queueMobileProductTitleAlign);

  // Shop-by-size and category changes may replace rail contents after load.
  // Observe the card-list children, not every price/variant DOM mutation.
  var sgTitleObservedLists = new WeakSet();
  function observeMobileProductTitleLists() {
    document.querySelectorAll(".sggc-products, .sgc-products, .collection__products")
      .forEach(function (list) {
        if (sgTitleObservedLists.has(list)) return;
        sgTitleObservedLists.add(list);
        new MutationObserver(queueMobileProductTitleAlign)
          .observe(list, { childList:true });
      });
  }
  document.addEventListener("shopify:section:load", observeMobileProductTitleLists);
  document.addEventListener("click", function () {
    window.requestAnimationFrame(queueMobileProductTitleAlign);
  }, true);
  observeMobileProductTitleLists();
  queueMobileProductTitleAlign();

  window.SGProductCardConfigurator = {
    ready: true,
    init: init
  };

  // Also handles orientation changes and the ResizeObserver fallback.
  var resizeQueued = false;

  window.addEventListener("resize", function () {
    if (resizeQueued) {
      return;
    }

    resizeQueued = true;

    window.requestAnimationFrame(function () {
      resizeQueued = false;

      document
        .querySelectorAll('.product-item[data-sg-configurator="true"]')
        .forEach(function (card) {
          // Preserve lazy initialization on the mobile homepage: resize must
          // not measure offscreen cards before the observer initializes them.
          // Other pages and desktop retain their original resize behavior.
          if (deferOffscreenCards && !card._sgConfiguratorReady) {
            return;
          }
          syncImageSizes(card);
        });
    });
  });

  // Homepage mobile: initialize configurable cards only as they approach view.
  // Liquid renders the initial image, price and selected options. This avoids
  // measuring and updating every offscreen card before the hero is painted.
  // All other templates, desktop and the theme editor retain eager init.
  var deferOffscreenCards =
    document.body &&
    document.body.classList.contains("template-index") &&
    window.matchMedia &&
    window.matchMedia("(max-width: 719px)").matches &&
    "IntersectionObserver" in window &&
    !(window.Shopify && window.Shopify.designMode);

  if (deferOffscreenCards) {
    var cardObserver = new window.IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }
          cardObserver.unobserve(entry.target);
          initCard(entry.target);
        });
      },
      { rootMargin: "500px 0px" }
    );

    document
      .querySelectorAll('.product-item[data-sg-configurator="true"]')
      .forEach(function (card) {
        cardObserver.observe(card);
      });
  } else {
    init(document);
  }
})();